export default __webpack_public_path__ + "static/media/continence.71ad2f50.svg";